export const EmployerRepAuthTypes = {
    SSO: 'sso',
    PAP: 'pap',
};